<h3>{{ location.FormattedLocation }}</h3>
